export const FULFILL_DOCUMENTS = 'DOCUMENTS.FULFILL';
export const UPLOAD_DOCUMENT = 'DOCUMENTS.UPLOAD';
export const GET_FORMS = 'DOCUMENTS.GET_FORMS';
